import React, { Component } from "react";
import MultiSelectDropDown from "./MultiselectDropDown";
import DropDown from "./DropDown";
import FilterButtonCollection from "./FilterButtonCollection";
import IntervalFilter from "./IntervalFilter";
import { getExtFromIntervalText } from "../constants/utils";

class GenericFilter extends Component {
    constructor(props) {
        super(props);
        this.bindThis();
        this.filterType = {
            MultiSelectDropDown: 0,
            FilterButtonCollection: 1,
            DropDown: 2,
            Interval: 3,
            Hidden: 4,
            NotSet: 5,
        };
    }

    bindThis() {
        // Make 'this' work in event functions
        this.onItemSelected = this.onItemSelected.bind(this);
    }

    onItemSelected(item) {
        if (item.url) {
            window.location.href = item.url;
            return;
        }

        this.props.onFilterChanged && this.props.onFilterChanged();
    }

    renderFilterGroup(filter) {
        const { articles } = this.props;

        if (articles?.length > 0 && filter?.id?.startsWith("Item")) {
            // Map the articles' dataCollection to a flat list of fieldName/fieldValue pairs
            // also include the fieldUnit as it's needed for matching
            const articleFieldValues = articles
                .flatMap(article => article.dataCollection)
                .map(({ fieldName, fieldValue, fieldUnit }) => ({ fieldName, fieldValue, fieldUnit }));

            filter.items = filter.items.filter(item => {
                return articleFieldValues.some(({ fieldName, fieldValue, fieldUnit }) => {
                    // Fix to make sure the matching is done with the fieldUnit
                    fieldValue = fieldValue + (fieldUnit ? ` ${fieldUnit}` : "");

                    // Match based on fieldName and check if the fieldValue includes the item's text
                    return (
                        filter.id === fieldName && fieldValue.split("|").includes(item.text)
                    );
                });
            });
        }

        switch (filter.type) {
            case this.filterType.MultiSelectDropDown:
                return (
                    <div className="c-product-overview__section c-product-overview__section--dropdown" key={filter.id}>
                        <MultiSelectDropDown
                            className="c-filter-dropdown c-filter-dropdown--multiselect"
                            items={filter.items}
                            title={filter.text}
                            onItemSelected={this.onItemSelected}
                            cssClass="c-filter-dropdown__select"
                        />
                    </div>
                );
            case this.filterType.DropDown:
                return (
                    <div className="c-product-overview__section c-product-overview__section--dropdown" key={filter.id}>
                        <DropDown items={filter.items} title={filter.text} onItemSelected={this.onItemSelected} />
                    </div>
                );
            case this.filterType.FilterButtonCollection:
                return (
                    <div className="c-product-overview__section c-product-overview__section--buttons" key={filter.id}>
                        {filter.id != "ContentTags" ? <span className="c-product-overview__title">{filter.text}</span> : null}
                        <FilterButtonCollection items={filter.items} title={filter.text} onItemSelected={this.onItemSelected} />
                    </div>
                );

            case this.filterType.Interval:
                const extension = filter?.items?.at(-1)?.text ?? "";

                return (
                    <div className="c-product-overview__section c-product-overview__section--interval" key={filter.id}>
                        {filter.id != "ContentTags" ? (
                            <span className="c-product-overview__title">
                                {filter.text} {getExtFromIntervalText(extension, true)}
                            </span>
                        ) : null}
                        <IntervalFilter filter={filter} onItemSelected={(values) => this.onItemSelected(values)} />
                    </div>
                );
            default:
                return null;
        }
    }

    render() {
        return (
            <>
                {this.props.filterGroups.filter(x => x.id?.startsWith("Item") ? x.items.length > 0 : x).map((filter) => {
                    return this.renderFilterGroup(filter);
                })}
            </>
        );
    }
}

export default GenericFilter;
